export function orderMenu<T>(menu: Record<string, T[]>, categoryOrder?: string[]): Record<string, T[]> {
  const ordered: Record<string, T[]> = {};
  for (const category of categoryOrder || []) {
    if (menu[category]) ordered[category] = menu[category];
  }
  for (const category of Object.keys(menu)) {
    if (!ordered[category]) ordered[category] = menu[category];
  }
  return ordered;
}
